export const GET_ERRORS = 'GET_ERRORS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const FETCH_USER_DATA = 'FETCH_USER_DATA';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const GET_USER = 'GET_USER';
export const UPDATE_USER = 'UPDATE_USER';
